import { ArrowLeft } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const LEGAL_PAGES = ['/cgu', '/mentions-legales', '/politique-de-confidentialite'];

export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useTheme();

  const handleBack = () => {
    if (LEGAL_PAGES.includes(location.pathname)) {
      navigate('/');
    } else if (location.pathname.startsWith('/cours/')) {
      navigate('/cours');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <button
      onClick={handleBack}
      className={`flex items-center text-${theme.text} hover:text-${theme.primary} transition-colors`}
    >
      <ArrowLeft className="h-5 w-5 mr-2" />
      <span>
        {LEGAL_PAGES.includes(location.pathname)
          ? 'Retour à l\'accueil'
          : location.pathname.startsWith('/cours/')
            ? 'Retour aux cours'
            : 'Retour au tableau de bord'}
      </span>
    </button>
  );
}